import React, { useEffect } from 'react';

function App(props) {
    if (props.simple) {
        return (
            <div
                className="mc23_icn"
                style={{
                    fontFamily: 'Mc23',
                    fontSize: props.size,
                    color: props.color,
                }}
            >
                {String.fromCharCode(parseInt(props.code, 16))}
            </div>
        );
    }

    const s = props.size + 20;

    return (
        <div
            className="bloc-mc23-circle"
            style={{
                borderRadius: props.radius,
                width: s,
                height: s,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: props.bg,
                boxShadow: props.shadow
                    ? '0 0 10px 0 rgba(0, 0, 0, 0.5)'
                    : 'none',
            }}
        >
            <div
                style={{
                    fontFamily: 'Mc23',

                    //fontSize: 25,
                    //color: props.color,
                }}
            >
                <div
                    style={{
                        fontFamily: 'Mc23',
                        fontSize: props.size,
                        color: props.color,
                    }}
                >
                    {String.fromCharCode(parseInt(props.code, 16))}
                </div>
            </div>
        </div>
    );
}

export default App;
